@if (progress() !== "unknown") {
  <div
    class="block h-[0.3rem] w-full min-w-[7rem] bg-n-400 rounded overflow-hidden"
  >
    <div
      [ngStyle]="{ transform: 'translateX(calc(-100% + ' + progress() + '%))' }"
      class="w-full h-full bg-n-1000 origin-left rounded transition-transform"
    ></div>
  </div>
} @else {
  <parkour-loading-spinner />
}
